const chunkMapping = {
	"1": [
		2
	],
	"2": [
		4
	],
	"3": [
		6
	],
	"4": [
		8
	],
	"5": [
		10
	],
	"6": [
		12
	],
	"7": [
		14
	],
	"8": [
		16
	],
	"9": [
		18
	],
	"10": [
		20
	],
	"11": [
		22
	],
	"12": [
		24
	],
	"13": [
		26
	],
	"14": [
		28
	],
	"15": [
		30
	],
	"16": [
		32
	],
	"17": [
		34
	],
	"18": [
		36
	],
	"19": [
		38
	],
	"20": [
		40
	],
	"21": [
		42
	],
	"22": [
		44
	],
	"23": [
		46
	],
	"24": [
		48
	],
	"25": [
		50
	],
	"26": [
		52
	],
	"27": [
		54
	],
	"28": [
		56
	],
	"29": [
		58
	],
	"30": [
		60
	],
	"31": [
		62
	],
	"32": [
		64
	],
	"33": [
		65
	],
	"34": [
		67
	],
	"35": [
		69
	],
	"36": [
		71
	],
	"37": [
		73
	],
	"38": [
		75
	],
	"39": [
		77
	],
	"40": [
		79
	],
	"41": [
		81
	],
	"42": [
		82
	],
	"43": [
		83
	],
	"44": [
		85
	],
	"45": [
		87
	],
	"46": [
		89
	],
	"47": [
		91
	],
	"48": [
		93
	],
	"49": [
		95
	],
	"50": [
		97
	],
	"51": [
		99
	]
};
const idToExternalAndNameMapping = {
	"2": [
		"default",
		"./Countries",
		3
	],
	"4": [
		"default",
		"./Claims",
		5
	],
	"6": [
		"default",
		"./PostalRate",
		7
	],
	"8": [
		"default",
		"./Invoices",
		9
	],
	"10": [
		"default",
		"./CountryGroups",
		11
	],
	"12": [
		"default",
		"./Sidebar",
		13
	],
	"14": [
		"default",
		"./Statistical",
		15
	],
	"16": [
		"default",
		"./Currency",
		17
	],
	"18": [
		"default",
		"./CurrencyExchangeRates",
		19
	],
	"20": [
		"default",
		"./PostalOperator",
		21
	],
	"22": [
		"default",
		"./Settlement",
		23
	],
	"24": [
		"default",
		"./Offices",
		25
	],
	"26": [
		"default",
		"./Exchange",
		27
	],
	"28": [
		"default",
		"./CompanyCode",
		29
	],
	"30": [
		"default",
		"./MailSubClass",
		31
	],
	"32": [
		"default",
		"./Emirate",
		33
	],
	"34": [
		"default",
		"./OfficeTypes",
		35
	],
	"36": [
		"default",
		"./PostalZones",
		37
	],
	"38": [
		"default",
		"./Carrier",
		39
	],
	"40": [
		"default",
		"./AirlineSector",
		41
	],
	"42": [
		"default",
		"./Airports",
		43
	],
	"44": [
		"default",
		"./Companies",
		45
	],
	"46": [
		"default",
		"./UserManagement",
		47
	],
	"48": [
		"default",
		"./TripTracking",
		49
	],
	"50": [
		"default",
		"./LiveTracking",
		51
	],
	"52": [
		"default",
		"./Dashboard",
		53
	],
	"54": [
		"default",
		"./Login",
		55
	],
	"56": [
		"default",
		"./Dashboard",
		57
	],
	"58": [
		"default",
		"./RouteDefinition",
		59
	],
	"60": [
		"default",
		"./FacilityDefinition",
		61
	],
	"62": [
		"default",
		"./TerritoryDefinition",
		63
	],
	"64": [
		"default",
		"./ZoneDefinition",
		61
	],
	"65": [
		"default",
		"./Users",
		66
	],
	"67": [
		"default",
		"./Roles",
		68
	],
	"69": [
		"default",
		"./Permissions",
		70
	],
	"71": [
		"default",
		"./Sector",
		72
	],
	"73": [
		"default",
		"./RouteList",
		74
	],
	"75": [
		"default",
		"./TripManagement",
		76
	],
	"77": [
		"default",
		"./CMS",
		78
	],
	"79": [
		"default",
		"./AMS",
		80
	],
	"81": [
		"default",
		"./Unauthorised",
		13
	],
	"82": [
		"default",
		"./Profile",
		13
	],
	"83": [
		"default",
		"./LiabilityAccount",
		84
	],
	"85": [
		"default",
		"./SupplierMapping",
		86
	],
	"87": [
		"default",
		"./CountryDetail",
		88
	],
	"89": [
		"default",
		"./Debriefing",
		90
	],
	"91": [
		"default",
		"./Shipment",
		92
	],
	"93": [
		"default",
		"./Pickup",
		94
	],
	"95": [
		"default",
		"./ControlTower",
		96
	],
	"97": [
		"default",
		"./VMS",
		98
	],
	"99": [
		"default",
		"./Rewards",
		100
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			let getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			const data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			const onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			const handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					const promise = fn(arg1, arg2);
					if(promise?.then) {
						const p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			const onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			const onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			const onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}